export default function serverCallPrefix(state = null, action) {
  switch (action.type) {
    case "SET_SERVER_CALL_PREFIX":
      return action.prefix
    default:
      return state
  }
}
